import { ReactElement } from "react";
import { RadioSelectorOption, H5 } from "@sellar-io/components";

export function BuyerOwnershipRadioElement({
  value,
  title,
}: {
  value: string;
  title?: string;
}): ReactElement {
  return (
    <RadioSelectorOption value={value}>
      <H5>{title}</H5>
    </RadioSelectorOption>
  );
}
